import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ProductProvider } from './context/ProductContext';
import { ThemeProvider } from './context/ThemeContext';
import { SiteProvider } from './context/SiteContext';
import { RedirectProvider } from './context/RedirectContext';

// Layout Components
import DocumentHead from './components/DocumentHead/DocumentHead';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import CartDrawer from './components/CartDrawer/CartDrawer';

// Page Components
import Home from './pages/Home';
import Shop from './components/Shop/Shop';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Category from './components/Category/Category';
import { AuthProvider } from './context/AuthContext';
import SignIn from './components/SignIn/SignIn';
import Checkout from './components/Checkout/Checkout';
import Account from './components/Account/Account';
import { WishlistProvider } from './context/WishlistContext';
import Wishlist from './components/Wishlist/Wishlist';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import ShippingPolicy from './pages/ShippingPolicy';
import ReturnsPolicy from './pages/ReturnsPolicy';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';

function App() {
  return (
  <SiteProvider>
  <RedirectProvider>
  <AuthProvider>
    <WishlistProvider>
    <CartProvider>
      <ProductProvider>
        <ThemeProvider>
          <Router>
            <DocumentHead />
            <div className="app">
              <Header />
              <CartDrawer />
              
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/category/:id" element={<Category />} />
                  <Route path="/category/:id/:subcategory" element={<Category />} />
                  <Route path="/sale" element={<Shop />} />
                  <Route path="/signin" element={<SignIn />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfUse />} />
                  <Route path="/shipping" element={<ShippingPolicy />} />
                  <Route path="/returns" element={<ReturnsPolicy />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faqs" element={<FAQs />} />
                </Routes>
              </main>
              
              <Footer />
            </div>
          </Router>
        </ThemeProvider>
      </ProductProvider>
    </CartProvider>
    </WishlistProvider>
  </AuthProvider>
  </RedirectProvider>
  </SiteProvider>
  );
}

export default App;
